module.exports = __webpack_public_path__ + "static/media/radioButtonMark.0dd33785.svg";